import { 
    UPLOAD_S3_MEDIA,
    UPLOAD_STARTED,
    UPLOAD_FINISHED,
    UPLOAD_PROGRESS
    } from '../actions/upload'
import { 
    CONVERT_MEDIA
} from '../actions/media'

import api from '@/utils/api'
import axios from 'axios'
import Vue from 'vue'

const state = {
	content:[],
    isUploading: false,
    uploadsInProgress:{}
}

const getters = {
    getIsUploading: state => state.isUploading,
    getUploadsInProgress: state => state.uploadsInProgress
}
const actions = {
	[UPLOAD_S3_MEDIA]:({commit, dispatch}, fileDetails) => {

        let url = 'upload-media'
        let uploadParams = {
            name: fileDetails.name,
            type: fileDetails.type,
            forRepository: fileDetails.forRepository
        }

        commit(UPLOAD_STARTED, fileDetails)

        //First we need to get a signed URL from AWS

        api({ url: url, data:uploadParams, method:"POST" })
        .then(response =>  {		
            return response.data
        })
        .then( uploadUrlData => {

            //Then we use the signed URL to PUT the file to S3

            var uploadURL = uploadUrlData.uploadURL
            var shouldConvert = uploadUrlData.shouldConvert

            var file = fileDetails.file
            var reader = new FileReader();
            
            reader.addEventListener('loadend', function(){
                
                let uploadData = new Blob([reader.result], {type: file.type})


                let config = {
                    headers: {
                        'Content-Type':file.type 
                    },
                    onUploadProgress: progressEvent => {
                        let progress = (progressEvent.loaded/progressEvent.total)*100
                        commit(UPLOAD_PROGRESS, {fileDetails:fileDetails, progress:progress})
                    }
                }

                axios.put(uploadURL, uploadData, config)
                .then( () =>  {		
                    commit(UPLOAD_FINISHED)
                    if(shouldConvert){
                        dispatch(CONVERT_MEDIA, fileDetails)
                    }
                })

            });

            reader.readAsArrayBuffer(fileDetails.file);

        })
        .then(() => {
        })				
        .catch(() => {

        });
            
    }
}

const mutations = {
    [UPLOAD_STARTED]: (state, context) => {
        state.isUploading = true;
        let progressItem = {
            "fileName":context.file.name,
            "progress":0
        }
        Vue.set(state.uploadsInProgress, context.fromComponent._uid, progressItem)
    },
    [UPLOAD_FINISHED]: (state) => {
        state.isUploading = false;
    },
    [UPLOAD_PROGRESS]: (state, context) => {
        state.isUploading = true;
        let progressItem = {
            "fileName":context.fileDetails.file.name,
            "progress":context.progress
        }
        Vue.set(state.uploadsInProgress, context.fileDetails.fromComponent._uid, progressItem)
    }
}

export default {
	state,
	getters,
	actions,
	mutations,
}